import React from "react";
import svg43 from "../../../../assets/svg/svg43.svg";
import { Progress } from "antd";
import { useSelector } from "react-redux";
import { cashConverter } from "../../../../utils";
function MonthlyProgressCard() {
  // Fetched by MonthlyDetailList; see monthly_report/fetch_project_header.
  const url = "monthly_report/fetch_project_header";

  const { rawHeader } = useSelector((state) => ({
    rawHeader: state.fetch.data[url],
  }));
  // A failed or empty fetch is stored as [].
  const header = rawHeader && !Array.isArray(rawHeader) ? rawHeader : {};

  // "--" rather than "KESNaN" when there is no figure.
  const money = (value) =>
    value === null || value === undefined || isNaN(Number(value))
      ? "--"
      : cashConverter(value);

  const items = [
    // The same four cards as the project view (ProjectCard).
    {
      title: "Contract Sum",
      amount: header?.contractSum,
    },
    {
      title: "Total IPC Value",
      amount: header?.totalIpcValue,
      progress: header?.totalIpcPercent,
    },
    {
      title: "Retained Amount",
      amount: header?.retainedAmount,
    },
    {
      title: "Balance",
      amount: header?.balance,
    },
  ];
  return (
    <div className="flex flex-shrink flex-wrap  gap-y-[1rem] gap-x-[1rem] mt-[1rem]">
      {items &&
        items?.map((item) => (
          <div className="rounded-[.5rem] border cursor-pointer border-[#D6E1F5] px-[.625rem] py-[1rem] h-auto bg-[#F7F7F7] w-auto lg:min-w-[190px]">
            <div className="flex items-center justify-between">
              <div
                className={`flex flex-col ${item?.progress ? "" : "w-full"}`}
              >
                <div className="flex  items-center justify-between">
                  <span className="font-interSans text-[.75rem] font-[500] text-[#0092CC]">
                    {item?.title}
                  </span>
                  <img src={svg43} alt="svg43" />
                </div>
                <div className="form-add-h lg:text-inherit !text-[18px] !text-[#050505] mt-[1.44rem]">
                  {money(item?.amount)}
                </div>
              </div>

              {item?.progress && (
                <div className="flex items-center flex-shrink-0">
                  <Progress
                    className={`object-contain w-[60px] h-[60px] ${
                      Number(item?.progress)?.toFixed(2) >
                      header?.progress
                        ? "blink-red"
                        : ""
                    }`}
                    type="circle"
                    percent={Number(item?.progress)?.toFixed(2)}
                    strokeColor={
                      Number(item?.progress)?.toFixed(2) >
                      header?.progress
                        ? "#B81B0E"
                        : "#4FAD5B"
                    }
                    format={(percent) => (
                      <span
                        style={{
                          color:
                            percent > header?.progress
                              ? "#B81B0E"
                              : "#4FAD5B",
                        }}
                      >
                        {percent}%
                      </span>
                    )}
                    width={60}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}

export default MonthlyProgressCard;
